/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.before-after-slider-outer' ).slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: $( '.before-after-nav-wrapper' ),
        prevArrow: '<button type="button" class=""><svg class="icon icon-left-arrow"><use xlink:href="#icon-left-arrow"></use></svg><span class="hidden lg:inline">Back</span></button>',
        nextArrow: '<button type="button" class=""><span class="hidden lg:inline">Next</span><svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></button>',
      } );

      // $( document ).on( 'click', '.sensitive-popup__unblur:not(.is)', function() {
      //   $( this ).closest( '.before-after-slider-outer' ).addClass( 'is-visible' );
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
